export const isBetweenTimes = (start: number, end: number) => {
  const time = new Date().getTime();
  return time >= start && time <= end;
};
